import Role from "../../lib/Role";

/**
 * @return {boolean}
 */
function CanReviewTemplateData(loggedInUser, template) {
    if (loggedInUser.role === Role.ADMIN) {
        return true;
    }
    return (loggedInUser.role === Role.REVIEWER
        || loggedInUser.role === Role.MANAGER)
        && template.reviewers.map(r => r.id).indexOf(loggedInUser.id) >= 0;
}
export default CanReviewTemplateData;